import { useInventoryProducts } from '@/services/product'

export const useServices = () => {
  const {
    products: services = [],
    isLoading,
    isFetched: isServicesDataFetched,
  } = useInventoryProducts({
    filters: {
      nature: { eq: 'service' },
      progress: { eq: 'active' },
      type: { eq: 'creation' },
    },
  })

  return { services, isLoading, isServicesDataFetched }
}
